import { faLightbulb } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import howItWorks from "../../../../../assets/imgs/onboarding/how-scribenote-works.gif";

const TipCard = ({ title, description }) => (
  <div className="p-4 flex flex-row items-center gap-3">
    <div className="text-warning">
      <FontAwesomeIcon icon={faLightbulb} size="lg" />
    </div>
    <div className="text-left">
      <h4 className="font-semibold text-white">{title}</h4>
      <p className="text-white/80 text-sm">{description}</p>
    </div>
  </div>
);

export const PdfExtractionLoading = () => (
  <div className="bg-white/10 rounded-xl p-2 border border-white/20 shadow-lg backdrop-blur-xs">
    <div className="flex flex-col items-center gap-6">
      <div className="w-full max-w-2xl">
        <div className="flex flex-col items-center gap-2">
          <h4 className="text-lg font-semibold text-white text-center">
            While you wait, learn how Scribenote works:
          </h4>
          <img
            src={howItWorks}
            alt="How it works"
            className="w-[90%] h-auto rounded-xl"
          />
          <TipCard title="Vets using Scribenote save about 10 minutes of documentation time per note." />
        </div>
      </div>
    </div>
  </div>
);

export default PdfExtractionLoading;
